import React from "react";
import { Link } from "react-router-dom";
import "./Items.css";

const Item = props => {
  return (
    <div className="item">
    <Link to= {`/product/${props.id}`}>  <img onClick={window.scrollTo(0,0)} src={props.image} alt="" /></Link>
      <p>{props.name}</p>
      <div className="item-prices">
        <div className="price-item-new">${props.new_price}</div>
        <div className="price-item-old">${props.old_price}</div>
      </div>
    </div>
  );
};

export default Item;
